import { Separator } from "@gigpro/ui/Separator";
import { cn } from "@gigpro/ui/tailwind/cn";
import { HireFeeProfileSection } from "domains/hire/containers/HireFeeProfileSection";
import { PROfileAboutContainer } from "domains/pros/containers/PROfileAbout";
import { PROfileCertificationsContainer } from "domains/pros/containers/PROfileCertifications";
import { PROfileExperienceContainer } from "domains/pros/containers/PROfileExperience";
import { PROfileGigHistorySummaryContainer } from "domains/pros/containers/PROfileGigHistorySummary";
import { PROfileHeaderContainer } from "domains/pros/containers/PROfileHeader";
import { PROfileReviewsContainer } from "domains/pros/containers/PROfileReviews";
import { PROfileSkillsContainer } from "domains/pros/containers/PROfileSkills";

interface ProProfileProps extends React.ComponentProps<"div"> {
  proId: number;
  preview?: boolean;
  admin?: boolean;
}

export const ProProfile = ({ proId, preview, admin, className, ...rest }: Readonly<ProProfileProps>) => (
  <div className={cn("@container/profile flex flex-col gap-y-5 rounded-sm bg-white pb-5", className)} {...rest}>
    <div className="mx-4 mt-4 flex flex-col gap-4 @3xl/profile:mx-8 @3xl/profile:flex-row @3xl/profile:items-start">
      <div className="min-w-0 flex-1">
        <PROfileHeaderContainer id={proId} preview={preview} admin={admin} />
      </div>
      {!preview && !admin && <HireFeeProfileSection proId={proId} />}
    </div>
    <Separator />
    <div className="mx-4 @md/profile:mx-8">
      <PROfileAboutContainer id={proId} />
    </div>
    <Separator />
    <div className="mx-4 @md/profile:mx-8">
      <PROfileReviewsContainer id={proId} />
    </div>
    <Separator />
    <div className="mx-4 @md/profile:mx-8">
      <PROfileGigHistorySummaryContainer id={proId} preview={preview} />
    </div>
    <Separator />
    <div className="mx-4 @md/profile:mx-8">
      <PROfileExperienceContainer id={proId} />
    </div>
    <Separator />
    <div className="mx-4 @md/profile:mx-8">
      <PROfileCertificationsContainer id={proId} />
    </div>
    <Separator />
    <div className="mx-4 @md/profile:mx-8">
      <PROfileSkillsContainer id={proId} />
    </div>
  </div>
);
